import GetCodeConfirmModal from "./GetCodeConfirm"
import GetCodeSuccessModal from "./GetCodeSuccess"
import ResubmitModal from "./Resubmit"
import VerifyModal from "./Verify"

const rewardModalComponents = {
  GetCodeConfirmModal,
  GetCodeSuccessModal,
  ResubmitModal,
  VerifyModal
}

export default rewardModalComponents